import { Toaster, Position, Intent, IconName } from '@blueprintjs/core';
import { types } from 'mobx-state-tree';

export function runAfterDelay(func: () => void, delay: number) {
  const t = setInterval(() => {
    func();
    clearInterval(t);
  }, delay);
}

export function showToast(
  message: string,
  iconName: IconName,
  intent: Intent = Intent.PRIMARY,
  position: Position = Position.TOP) {
  Toaster
    .create({ position })
    .show({
      // tslint:disable-next-line:no-any
      iconName,
      intent,
      message
    });
}

export const ToggleModel = types.model('Toggle', {
  value: types.optional(types.boolean, false),
}, {
    setValue(value: boolean) {
      this.value = value;
    },
    toggle() {
      this.value = !this.value;
    }
  }
);

export const StringControlModel = types.model('StringControl', {
  value: types.maybe(types.string),

  get isEmpty() {
    return this.value === null || this.value === '' || this.value === undefined || this.value.trim() === '';
  }
}, {
  setValue(newValue: string | null) {
    this.value = newValue;
  }
});

export const IntegerControlModel = types.model('IntegerControl', {
  value: types.optional(types.number, 0),
  min: types.optional(types.number, 0),
  max: types.number
}, {
  increment() {
    this.setValue(this.value + 1);
  },

  decrement() {
    this.setValue(this.value - 1);
  },

  setValue(newValue: number) {
    if (newValue <= this.max && newValue >= this.min) {
      this.value = newValue;
    }
  }
});


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/pageUtils.ts